import { Box, Flex, Icon, Img, Text } from "@chakra-ui/react";
import { FaFileExport, FaMoneyBill } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import { BLUEMONEDD, BLUEMONEDDBUTTONS } from "../../../constants/colors";
import maquininha from "../../../assets/images/maquininha-monedd.png";

export default function Simulator({setIsOpen}: any) {

    return (
        <Flex
            // w={"90%"}
            // h={"50%"}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Flex 
                h={"7vw"} 
                // minWidth={"100px"} 
                w={"8vw"}
                mr={"-1.5vw"} 
                bgColor={"#1C3E92"}
                alignItems={"center"}
                justifyContent={"flex-start"}
                pl={"35px"}
                borderRadius={"20px 0 0 20px"}
                onClick={() => setIsOpen(true)}
                _hover={{cursor: "pointer"}}
                // pt={"10px"}
            >
                <Text w={"60%"} fontWeight={"bold"} color={"white"} fontSize={"0.8vw"}>SIMULE UMA VENDA</Text>
            </Flex>
            <Img 
                _hover={{cursor: "pointer"}} 
                onClick={() => setIsOpen(true)} 
                // ml={"150px"} 
                // position={"relative"}
                // zIndex={1} 
                h={"15vw"} 
                src={maquininha}
            ></Img>
        </Flex>
    );
}